import React, { useCallback, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

import ClientesTab from "./clientes/ClientesTab";
import ModulosTab from "./modulos/ModulosTab";
import PagamentosTab from "./pagamentos/PagamentosTab";
import ProdutosTab from "./produtos/ProdutosTab";
import VisaoGeralTab from "./visao-geral/VisaoGeralTab";

const SECOES = {
  "visao-geral": { titulo: "Relatório de Vendas", subtitulo: "Dashboard completo de vendas e desempenho", Tab: VisaoGeralTab },
  produtos: { titulo: "Relatório de Produtos", subtitulo: "Top produtos, CMV, lucro e desempenho por módulo", Tab: ProdutosTab },
  modulos: { titulo: "Relatório de Módulos", subtitulo: "Vendas, CMV, despesas e lucro de cada canal de venda", Tab: ModulosTab },
  pagamentos: { titulo: "Relatório de Pagamentos", subtitulo: "Formas de pagamento mais usadas", Tab: PagamentosTab },
  // Sem item de menu: abre pelo "Ver todos →" do Top Clientes (achado 77).
  clientes: { titulo: "Clientes do período", subtitulo: "Todos os clientes identificados, do que mais gastou ao que menos gastou", Tab: ClientesTab },
};

// Cada seção tem rota própria no menu; os atalhos de dentro do Relatório de
// Vendas levam à rota dela (antes trocavam o conteúdo sem mudar o endereço).
const ROTAS = { modulos: "/admin/vendas/relatorio-modulos", pagamentos: "/admin/vendas/relatorio-pagamentos" };

// Relatórios → Relatório de Vendas / Produtos / Módulos / Pagamentos.
export default function RelatorioVendasPage({ defaultTab }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [secao, setSecao] = useState(defaultTab || searchParams.get("tab") || "visao-geral");
  const [acao, setAcao] = useState({ recarregar: null, carregando: false });
  // Período levado do Relatório de Vendas para a lista de Clientes, e de volta.
  const [periodoLevado, setPeriodoLevado] = useState(null);

  const meta = SECOES[secao] || SECOES["visao-geral"];
  const definirAtualizar = useCallback((a) => setAcao(a), []);
  const abrirSecao = useCallback((s, periodo) => {
    if (ROTAS[s]) return navigate(ROTAS[s]);
    setPeriodoLevado(periodo || null);
    setSecao(s);
  }, [navigate]);
  const Tab = SECOES[secao]?.Tab;

  return (
    <div className="p-4 sm:p-6 space-y-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold">{meta.titulo}</h1>
          <p className="text-muted-foreground mt-1">{meta.subtitulo}</p>
        </div>
        {Tab && (
          <Button variant="outline" onClick={() => acao.recarregar?.()} disabled={acao.carregando || !acao.recarregar} className="gap-2">
            <RefreshCw className={`w-4 h-4 ${acao.carregando ? "animate-spin" : ""}`} />
            Atualizar
          </Button>
        )}
      </div>
      {Tab && <Tab definirAtualizar={definirAtualizar} onAbrirSecao={abrirSecao} periodoInicial={periodoLevado}
        onVoltar={(periodo) => { if (periodo) setPeriodoLevado(periodo); setSecao("visao-geral"); }} />}
    </div>
  );
}
